import { createContext } from "react";
import { DialogType } from "./DialogProvider";

export interface DialogOptions {
  confirmButton?: boolean;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export type DialogContext = {
  status: DialogType;
  dialogTitle: string;
  dialogMessage: string;
  dialogMessage2: string;
  options: DialogOptions;
  success: (message: string, title?: string, options?: DialogOptions) => void;
  error: (
    message: string,
    message2?: string,
    title?: string,
    options?: DialogOptions,
  ) => void;
  warning: (
    message: string,
    title?: string,
    timeout?: number,
    options?: DialogOptions,
  ) => void;
  clear: (value?: React.SetStateAction<string>) => void;
};

const DialogContext = createContext<DialogContext>(null);
// for debugging
DialogContext.displayName = "DialogContext";

export default DialogContext;
